/*
 * File: d:\projects\AutoFiFront\src\Content\CollapseBox\CollapseBox2.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday April 21st 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday April 21st 2023 10:26:45 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import translator from 'MultiLanguage/TranslationWrapper';
import React, { useCallback, useState } from 'react';
import { Collapse } from 'react-collapse';
import styles from 'Content/CollapseBox/CollapseBox.module.css';
import { IoIosArrowDropdownCircle } from 'react-icons/io';
import { BuildText } from 'Utils/BuildText';

type CollapseBox2Props = {
    context: string,
};

function CollapseBox2(props: CollapseBox2Props) {
    const [isButtonCollapseOpen, setIsButtonCollapseOpen] = useState(false);
    const onClick = useCallback(
        () => setIsButtonCollapseOpen(!isButtonCollapseOpen),
        [isButtonCollapseOpen]
    );
    const legalObject = translator.decode(`financementText.${props.context}`);
    const rows = BuildText(legalObject,`${props.context}`);
    return (
        <React.Fragment>
            <div className={`${styles.question}`}>
                <button className={`${styles.questionButton}`} onClick={onClick}>
                    <div className={`${styles.questionText}`}>
                        {translator.decode(`financementText.${props.context}.title`)}
                    </div>
                    <IoIosArrowDropdownCircle fill='var(--theme-color)'/>
                </button>
            </div>
            <Collapse isOpened={isButtonCollapseOpen}>
                <div className={`${styles.tabulation}`}>
                    {rows}
                </div>
            </Collapse>
        </React.Fragment>
    )
}

export default CollapseBox2;
